import React from "react";

export interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const HamburgerButton = ({ isOpen, onClick }: HamburgerButtonProps) => {
  return (
    <div className="HamburgerButton">
      <button
        className="flex flex-col justify-around w-4 h-4 p-0 bg-transparent cursor-pointer focus:outline-none"
        onClick={onClick}
      >
        <div
          className="w-full transition-all duration-300 bg-black"
          style={{
            height: "2px",
            transform: isOpen ? "translateY(270%) rotate(45deg)" : "",
          }}
        ></div>
        <div
          className="w-full transition-all duration-300 bg-black"
          style={{
            height: "2px",
            transform: isOpen ? "translateX(100%)" : "",
            opacity: isOpen ? "0" : "1",
          }}
        ></div>
        <div
          className="w-full transition-all duration-300 bg-black"
          style={{
            height: "2px",
            transform: isOpen ? "translateY(-270%) rotate(-45deg)" : "",
          }}
        ></div>
      </button>
    </div>
  );
};

export default HamburgerButton;
